module.exports = __webpack_public_path__ + "static/media/uncle.2c15e340.svg";